import Header from "../components/Header";
import LecturesTable from "./components/LecturesTable";

function LecturesPage() {
    let pagesLinks = [
        {
            name: "المحاضرات",
            link: `/`,
        },
        { name: "الصفحة الرئيسية", link: `/` },
        {
            name: "الفصول الدراسية",
            link: `/admin/courses`,
        },
    ];
    return (
        <div>
            <Header
                pageName="المحاضرات"
                pages={pagesLinks}
                className="text-2xl"
            />
            <LecturesTable />
        </div>
    );
}

export default LecturesPage;
